// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
//import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import MKTypography from "components/MKTypography";
import team2 from "assets/images/Contact2.jpeg";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";

function Information() {
  return (
    <MKBox component="section" py={4}>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3"> We operate from </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              65 Nelumpura Road Moratuwa. Sri Lanka.
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              <WhatsAppIcon></WhatsAppIcon> +94 774 570 342
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              <Icon>email</Icon> dive@scubaaddicts.lk
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={5} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <Card sx={{ maxWidth: 500, borderRadius: 3, boxShadow: 3 }}>
              <CardMedia
                component="img"
                image={team2}
                alt="Team Member"
                sx={{ height: 350, objectFit: "cover" }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
